import { processGqlDataAsArray } from '../use-builders-to-process-gql-data';
import type { HtmlFromDotcms } from './converters-from-dotcms';
import {
  convertDotcmsResponseToRecord,
  convertDotcmsStringNonNullable,
  wrapDotcmsHtml,
} from './converters-from-dotcms';
import type { IBaseObjectData } from './dotcms-base-object';
import type { IDotKeyValueData } from './dotcms-dotkeyvalue';
import { DotKeyValueGqlHelper } from './dotcms-dotkeyvalue';
import type { ILinkData } from './dotcms-link';
import { LinkGqlHelper } from './dotcms-link';
import { buildGqlFieldsQuery } from './gql-builders';
import type { IGqlHelper } from './gql-helper';

export type ILoginFormSsoIssuerData = IBaseObjectData & {
  headline: HtmlFromDotcms;
  loginMethodActiveButtonText: HtmlFromDotcms;
  loginMethodTerminatedButtonText: HtmlFromDotcms;
  loginMethodBusinessGroupsSeparator: string;
  loginMethodsButtonText: IDotKeyValueData[];
  activeEmployeeLoginName: HtmlFromDotcms;
  formerEmployeeLoginName: HtmlFromDotcms;
  adminLoginName: HtmlFromDotcms;
  contactUsLink?: ILinkData;
};

export const LoginFormSsoIssuerGqlHelper: IGqlHelper<ILoginFormSsoIssuerData> =
  {
    contentTypeName: 'LoginFormSsoIssuer',
    gqlFieldsQuery: `
    headline
    loginMethodActiveButtonText
    loginMethodTerminatedButtonText
    loginMethodBusinessGroupsSeparator
    loginMethodsButtonText { ${DotKeyValueGqlHelper.gqlFieldsQuery} }
    activeEmployeeLoginName
    formerEmployeeLoginName
    adminLoginName
    contactUsLink { ${buildGqlFieldsQuery(LinkGqlHelper)} }
  `,
    processGqlData: (gqlResponse: unknown) => {
      if (!gqlResponse) {
        return undefined;
      }

      const {
        headline,
        loginMethodActiveButtonText,
        loginMethodTerminatedButtonText,
        loginMethodBusinessGroupsSeparator,
        loginMethodsButtonText,
        activeEmployeeLoginName,
        formerEmployeeLoginName,
        adminLoginName,
        contactUsLink,
      } = convertDotcmsResponseToRecord(gqlResponse);

      return {
        headline: wrapDotcmsHtml(headline),
        loginMethodActiveButtonText: wrapDotcmsHtml(
          loginMethodActiveButtonText,
        ),
        loginMethodTerminatedButtonText: wrapDotcmsHtml(
          loginMethodTerminatedButtonText,
        ),
        loginMethodBusinessGroupsSeparator: convertDotcmsStringNonNullable(
          loginMethodBusinessGroupsSeparator,
        ),
        loginMethodsButtonText:
          processGqlDataAsArray(
            DotKeyValueGqlHelper,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            loginMethodsButtonText,
          ) ?? [],
        activeEmployeeLoginName: wrapDotcmsHtml(activeEmployeeLoginName),
        formerEmployeeLoginName: wrapDotcmsHtml(formerEmployeeLoginName),
        adminLoginName: wrapDotcmsHtml(adminLoginName),
        contactUsLink: LinkGqlHelper.processGqlData(contactUsLink),
      };
    },
  };
